const state = {
 view_modal: false,
 add_modal: false,
 edit_modal: false,
 modal: {
  contact_id: null,
  company_id: null,
  company_name: null,
  row_node_id: null,
 },

 current_profile_contact_id: null,
 current_profile_tab_index: null,
 current_row_id: null,
 
 reload_contacts: false,
 delete_contact_id: null,
 update_contact_id: null,
};
const actions = {};

const mutations = {
 SHOW_VIEW_CONTACT_MODAL(state, payload) {
  state.view_modal = true;
  state.add_modal = false;
  state.edit_modal = false;
  state.modal.contact_id = payload.contact_id;
  state.modal.company_id = payload.company_id;
  state.modal.company_name = payload.company_name;
  state.modal.row_node_id = payload.row_node_id;
 },
 SHOW_ADD_CONTACT_MODAL(state, payload) {
  state.view_modal = false;
  state.add_modal = true;
  state.edit_modal = false;
  state.modal.company_id = payload.company_id;
  state.modal.company_name = payload.company_name;
  state.modal.row_node_id = payload.row_node_id;
 },
 SHOW_EDIT_CONTACT_MODAL(state, payload) {
  state.view_modal = false;
  state.add_modal = false;
  state.edit_modal = true;
  state.modal.contact_id = payload.contact_id;
  state.modal.company_id = payload.company_id;
  state.modal.company_name = payload.company_name;
  state.modal.row_node_id = payload.row_node_id;
 },
 HIDE_CONTACT_MODAL(state) {
  state.view_modal = false;
  state.add_modal = false;
  state.edit_modal = false;
  state.modal.contact_id = null;
  state.modal.company_id = null;
  state.modal.company_name = null;
  state.modal.row_node_id = null;
 },
 CURRENT_PROFILE_CONTACT_ID(state, contact_id) {
  state.current_profile_contact_id = contact_id
 },
 SET_CONTACT_TAB_INDEX(state, tab_index) {
  state.current_profile_tab_index = tab_index;
 },
 SET_CONTACT_ROW_ID(state, row_id) {
  state.current_row_id = row_id;
 },
 CLEAR_CURRENT_ROW_ID(state) {
  state.current_row_id = null;
 },
 RELOAD_CONTACTS(state, payload) {
  state.reload_contacts = payload.action;
 },
 
 SET_DELETE_CONTACT_ID(state, payload) {
  state.delete_contact_id = payload;
 },
 SET_UPDATE_CONTACT_ID(state, payload) {
  state.update_contact_id = payload;
 },
};

export default {
 state,
 actions,
 mutations
}
